// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var UseGetFocusableElement = require("../../../hook/UseGetFocusableElement.bs.js");
var Molecule_RedirectionAnchor = require("../../molecule/Molecule_RedirectionAnchor.bs.js");

function Organism_HeaderRedirectionAnchor(Props) {
  var labels = Props.labels;
  var searchNavigation = Props.searchNavigation;
  var match = UseGetFocusableElement.make(undefined);
  var htmlElement = match[0];
  var handleClick = function (param) {
    Belt_Option.forEach(htmlElement, (function (prim) {
            prim.focus();
          }));
  };
  var left = htmlElement !== undefined ? ({
        NAME: "Button",
        VAL: {
          onClick: handleClick,
          label: match[1] ? labels.redirectPlayerLabel : labels.redirectMainLabel
        }
      }) : undefined;
  var right_1 = {
    href: searchNavigation.href,
    label: labels.redirectSearchLabel,
    target: "Blank"
  };
  var right = {
    NAME: "Link",
    VAL: right_1
  };
  var tmp = {
    right: right
  };
  if (left !== undefined) {
    tmp.left = Caml_option.valFromOption(left);
  }
  return React.createElement(Molecule_RedirectionAnchor.make, tmp);
}

Organism_HeaderRedirectionAnchor.displayName = "HeaderRedirectionAnchor";

var make = Organism_HeaderRedirectionAnchor;

exports.make = make;
/*  Not a pure module */
